import React from 'react';
import { useLang } from '@/context/LangContext';

export default function LangSwitcher({ className = '' }) {
    const { lang, setLang } = useLang();
    return (
        <div className={`inline-flex items-center rounded-full border border-border bg-surface p-0.5 text-xs font-medium ${className}`} data-testid="lang-switcher">
            <button
                type="button"
                onClick={() => setLang('fr')}
                className={`px-3 py-1 rounded-full transition-all ${lang === 'fr' ? 'bg-primary text-primary-foreground shadow-soft' : 'text-muted-foreground hover:text-foreground'}`}
                data-testid="lang-fr-btn"
            >FR</button>
            <button
                type="button"
                onClick={() => setLang('en')}
                className={`px-3 py-1 rounded-full transition-all ${lang === 'en' ? 'bg-primary text-primary-foreground shadow-soft' : 'text-muted-foreground hover:text-foreground'}`}
                data-testid="lang-en-btn"
            >EN</button>
        </div>
    );
}
